import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './header.css';
import hammburger from '../../assets/hamburger.svg';
import { useHistory } from "react-router-dom";
import logo from '../../assets/c3-logo.png';

function Header() {
    const history = useHistory();

    const handleClick = () =>{
        history.push("/contact");
    }

    const mobileClick = () => {
        setOpenMenu(!openMenu)
    }

   const [openMenu, setOpenMenu] = useState(false);
    const [active, setActive] = useState();

    useEffect(() => {
        if (typeof window !== "undefined") {
            window.addEventListener("scroll", () =>
              setActive(window.pageYOffset > 200)
            );
          }
    }, [])
    return (
        <>
        <div className={`${active ? 'header__active' : 'header__main'} `}>
            <div className="header__logo">
                <img src={logo} alt="" srcset="" />
            </div>
            <div className="header__links">
                <Link to='/'> Home </Link>
                <Link to='about'> About </Link>
                <Link to='course'> Courses </Link>
                <Link to='blog'> Blog </Link>
                <Link to='faq'> Faq </Link>
                <button className='primary__button' onClick={handleClick}> Contact us </button>
            </div>
            <div className="header__mobile">
                <img onClick={mobileClick} src={hammburger} alt="" />
            </div>
         
        </div>
        <div className={`${openMenu ? "mobile__menu active__menu " : 'mobile__menu'}`}>
                <div className="mobile__top">
                     <img src={logo} alt="" srcset="" />
                     <button onClick={mobileClick}> ✖ </button>
                </div>
                <div className="mobile__bottom">

                    <Link onClick={mobileClick} to='/'> <p> 🏠  Home </p> <span> ➡</span></Link>
                    <Link onClick={mobileClick} to='about'><p> 💻  About Us </p> <span>➡ </span></Link>
                    <Link onClick={mobileClick} to='course'> <p> 📚  Courses </p>  <span>➡ </span> </Link>
                    <Link onClick={mobileClick} to='blog'> <p> 🖨  Blog </p>  <span>➡ </span> </Link>
                    <Link onClick={mobileClick} to='faq'> <p> ❓  Faq </p>   <span>➡ </span></Link>
                    <Link onClick={mobileClick} to='contact'> <p> 📞  Contact Us </p>   <span>➡ </span></Link>
                </div>
            </div>
        </>
    )
}

export default Header
